import { useEffect, useRef } from 'react'
import { useAppStore } from '@store'

export default function useSyncFrontalWithEncimera() {
  const items = useAppStore((s) => s.items)
  const frontalActive = useAppStore((s) => s.frontalActive)
  const mapping = useAppStore((s) => s.frontalesOptions)
  const texturesOptions = useAppStore((s) => s.frontalesTexturesOptions) as any[] | undefined

  const lastAppliedRef = useRef<string | null>(null)

  useEffect(() => {
    if (!frontalActive || !mapping || !texturesOptions || !items?.size) {
      return
    }

    const encimera: any = Array.from(items.values()).find(
      (it: any) =>
        it?.type === 'linkedSon' &&
        (it?.typeOfSon === 'Encimera' || it?.description === 'Encimera'),
    )

    const encimeraTex = encimera?.textures?.find(
      (t: any) => t.zoneDisplayName === 'Encimera',
    ) as any

    const encimeraTextureName: string | undefined = encimeraTex?.name?.trim()

    if (!encimeraTextureName) {
      return
    }

    const frontalCode = (mapping as Record<string, string>)[encimeraTextureName]

    if (!frontalCode) {
      return
    }

    const currentKey = `${encimeraTextureName}->${frontalCode}`
    if (lastAppliedRef.current === currentKey) {
      return
    }

    const targetTex = texturesOptions.find(
      (t: any) =>
        t?.nombre?.trim() === frontalCode?.trim() || t?.descripcion?.trim() === frontalCode?.trim(),
    )

    if (!targetTex) {
      return
    }

    useAppStore.setState((store) => {
      const frontalEntries = Array.from(store.items.entries()).filter(
        ([, v]: [string, any]) => v?.type === 'linkedItem' && v?.catalogID === 'Frontal',
      ) as [string, any][]

      frontalEntries.forEach(([fid, fitem]) => {
        // console.log(`[useSyncFrontalWithEncimera] Procesando frontal: ${fid}`)
        const texIdx = fitem?.textures?.findIndex(
          (tx: any) => tx.zoneDisplayName === 'Frontal' || tx.modelo === 'Frontal',
        )
        if (texIdx != null && texIdx >= 0) {
          const prev = fitem.textures[texIdx]
          const mini = targetTex.urlMiniatura || targetTex.miniatura || prev?.img
          fitem.textures[texIdx] = {
            ...prev,
            name: targetTex.nombre ?? targetTex.descripcion ?? prev?.name,
            url: targetTex.url ?? prev?.url,
            description: targetTex.descripcion ?? prev?.description,
            acabado: prev?.acabado ?? 'Frontal',
            img: mini,
            id: targetTex.identificadorTextura ?? prev?.id,
            searchID: targetTex.idTexturas ?? prev?.searchID,
          }
          if (mini) {
            fitem.image = mini
          }

          const zoneName = prev?.zoneName || fitem.textures[texIdx]?.zoneName
          if (zoneName && fitem.zones && fitem.zones[zoneName]) {
            const matPrev = fitem.zones[zoneName].material || {}
            fitem.zones[zoneName].material = {
              ...matPrev,
              name: targetTex.nombre ?? targetTex.descripcion ?? matPrev?.name,
              description: targetTex.descripcion ?? matPrev?.description,
              url: targetTex.url ?? matPrev?.url,
              img: mini ?? matPrev?.img,
              acabado: matPrev?.acabado ?? 'Frontal',
              groupID: targetTex.idGruposDeTexturas ?? matPrev?.groupID,
              id: targetTex.identificadorTextura ?? matPrev?.id,
              searchID: targetTex.idTexturas ?? matPrev?.searchID,
            }
          }
        }
      })
    })

    lastAppliedRef.current = `${encimeraTextureName}->${frontalCode}`
  }, [items, frontalActive, mapping, texturesOptions])
}
